import { ChannelType } from '../constants/channel-type.constants';
import { AuthorizationStatus } from '../constants/authorization-status-constants';
import { OperationType } from '../constants/operation-type.constants';
import { Moment } from 'moment';

export interface IAuthorizationStartRequest {
  operationType: OperationType;
  channel?: ChannelType | null;
  channelInfo?: string;
}

/**
 * Authorization Start request.
 * Contains information about the operation type, channel type and payload for channel
 */
export class AuthorizationStartRequest implements IAuthorizationStartRequest {
  constructor(public operationType: OperationType, public channel?: ChannelType | null, public channelInfo?: string) { }
}

export interface IAuthorizationStartResponse {
  authRequestId: string;
  expireIn: number;
  interval: number;
  channel: ChannelType;
  channelInfo: string;
  uniqueRequestCode?: string;
}

/**
 * Authorization Start response from server.
 * Contains the authorization request identifier and other info
 */
export class AuthorizationStartResponse implements IAuthorizationStartResponse {
  constructor(
    public authRequestId: string,
    public expireIn: number,
    public interval: number,
    public channel: ChannelType,
    public channelInfo: string,
    public uniqueRequestCode?: string
  ) { }
}

export interface IAuthorizationStatusResponse {
  authRequestId: string;
  status: AuthorizationStatus;
  nextRequestNotBefore?: Moment;
}

/**
 * Authorization status response from server.
 * Contains info about a determinated authorization, like the authorization status and when a client can ask for a new authorization
 */
export class AuthorizationStatusResponse implements IAuthorizationStatusResponse {
  constructor(public authRequestId: string, public status: AuthorizationStatus, public nextRequestNotBefore?: Moment) { }
}

export interface IAuthorizationEndRequest {
  verificationCode?: string;
  consumed?: boolean;
  approved?: boolean;
  operationType?: string;
  channelType?: ChannelType;
}

/**
 * Authorization end request.
 * Can contain information about the verification code inserted by user in some kind of channel flow (like EMAIL or SMS) and other info
 */
export class AuthorizationEndRequest implements IAuthorizationEndRequest {
  constructor(
    public verificationCode?: string,
    public consumed?: boolean,
    public approved?: boolean,
    public operationType?: string,
    public channelType?: ChannelType
  ) { }
}

export interface IAuthorizationEndResponse {
  authPermission: string;
  success: boolean;
  remainingAttempts: number;
}

/**
 * Authorization end response.
 * Contains info about authorization request flow completition. If success is true, the authorization is guaranteed
 */
export class AuthorizationEndResponse implements IAuthorizationEndResponse {
  constructor(public authPermission: string, public success: boolean, public remainingAttempts: number) { }
}
